import { BaseRouteService } from 'core/services';

class ChannelRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'channels/';
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}

	get(id, options) {
		return super.get(this.base + '{id}/{?embed}', id, options);
	}

	create(sourceOfChange) {
		return super.create(this.base + '/?sourceOfChange={sourceOfChange}', { sourceOfChange });
	}

	update(resource, sourceOfChange) {
		return super.update(this.base + '{id}/?sourceOfChange={sourceOfChange}', resource, { sourceOfChange });
	}

	delete(resource) {
		return super.delete(this.base + '{id}', resource);
	}

	authorizeAmazon(oAuthDate) {
		return super.create(this.base + 'authorizeAmazon/?oAuthDate={oAuthDate}', {
			oAuthDate,
		});
	}

	getGoFlowStores(resource) {
		return super.create(this.base + 'getGoFlowStores', resource);
	}

	getSellerCloudCompanies(resource) {
		return super.create(this.base + 'getSellerCloudCompanies', resource);
	}

	getSellerCloudUrl(teamName) {
		return super.get(this.base + 'getSellerCloudUrl/{id}', teamName);
	}

	authorizationResultAmazon(state) {
		return super.create(this.base + 'authorizationResultAmazon/?state={state}', { state });
	}

	updateChannelWarehouseCodes(updateChannelWarehouseCodesParams, sourceOfChange) {
		return super.update(
			this.base + 'update-warehouse-codes/?sourceOfChange={sourceOfChange}',
			updateChannelWarehouseCodesParams,
			{ sourceOfChange }
		);
	}

	updateChannelAmazonTemplates(updateChannelAmazonTemplates, sourceOfChange) {
		return super.update(
			this.base + 'update-amazon-templates/?sourceOfChange={sourceOfChange}',
			updateChannelAmazonTemplates,
			{ sourceOfChange }
		);
	}

	updateChannelCustomLabel(updateChannelCustomLabelParams, sourceOfChange) {
		return super.update(
			this.base + 'update-custom-label/?sourceOfChange={sourceOfChange}',
			updateChannelCustomLabelParams,
			{ sourceOfChange }
		);
	}
}
export default ChannelRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/ChannelRouteService.js